import React, { memo, useEffect, useRef, useState, useCallback } from 'react';
import {
  Switch,
  Route,
  NavLink,
  useRouteMatch,
  Redirect,
  useLocation,
  useHistory,
} from 'react-router-dom';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';

import Nav from './Nav';
import { CONTEXT } from '../../config';
import WallpaperRecommend from './WallpaperRecommend/WallpaperRecommend';
import WallpaperCategory from './WallpaperCategory/WallpaperCategory';
import WallpaperMine from './WallpaperMine/index';
import WallpaperHotRank from './WallpaperHotRank/WallpaperHotRank';
import styles from './Index.module.less';
import { createShortcut } from '../../actions/layout';
import { PCStoreJsBridge } from '../../nativeapi';
import { localSetItem, localGetItem } from '../../utils/utils';
import { logging } from '../../actions/log';

const tab = [
  { code: 1, url: 'wprecommend', pageType: 'wallpaper', source: 'Wallpaper_Reco', codeType: 1 },
  { code: 2, url: 'wphot', pageType: 'wallpaperHot', source: 'Wallpaper_Hot', codeType: 4 },
  { code: 3, url: 'wprankpage', pageType: 'wallpaperRank', source: 'Wallpaper_Rank', codeType: 4 },
  { code: 4, url: 'wpcategory', codeType: 2 },
  { code: 5, url: 'wpmine', codeType: 3 },
];

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectAboutVisible = createSelector(
  state => state.layout,
  layout => layout.AboutVisible,
);

const selectCheckUpdate = createSelector(
  state => state.layout,
  layout => layout.checkUpdateVisible,
);

const selectReleaseNotesVisible = createSelector(
  state => state.layout,
  layout => layout.releaseNotesVisible,
);

const selectUserFeedbackVisible = createSelector(
  state => state.layout,
  layout => layout.userFeedbackVisible,
);

const selectShareVisible = createSelector(
  state => state.layout,
  layout => layout.shareVisible,
);

const selectWallpaper = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectMessageVisible = createSelector(
  state => state.layout,
  layout => layout.messageVisible,
);

const selectPinPopCloseVisible = createSelector(
  state => state.layout,
  layout => layout.pinPopCloseVisible,
);
export default memo(() => {
  const dispatch = useDispatch();
  const { path, url } = useRouteMatch();
  const { pathname } = useLocation();
  const [active, setActive] = useState(null);
  const userInfo = useSelector(selectUserInfo);
  const AboutVisible = useSelector(selectAboutVisible);
  const checkUpdateVisible = useSelector(selectCheckUpdate);
  const releaseNotesVisible = useSelector(selectReleaseNotesVisible);
  const userFeedbackVisible = useSelector(selectUserFeedbackVisible);
  const shareVisible = useSelector(selectShareVisible);
  const { wpShowOrder } = useSelector(selectWallpaper);
  const logInfoData = useSelector(selectLogInfo);
  const messageVisible = useSelector(selectMessageVisible); // 消息中心
  const pinPopCloseVisible = useSelector(selectPinPopCloseVisible);

  useEffect(() => {
    if (pathname.indexOf('wprecommend') > -1) {
      setActive('wprecommend');
    } else if (pathname.indexOf('wpcategory') > -1) {
      setActive('wpcategory');
    } else if (pathname.indexOf('wpmine') > -1) {
      setActive('wpmine');
    } else if (pathname.indexOf('wphot') > -1) {
      setActive('wphot');
    } else if (pathname.indexOf('wprankpage') > -1) {
      setActive('wprankpage');
    }
  }, [pathname]);

  // 判断是否有快捷方式 FIRST_WALLPAPER_ENTER
  useEffect(() => {
    let times = '';
    let num = 11;
    let localNum = ~~localGetItem('FIRST_WALLPAPER_ENTER_87');
    if (localNum && localNum > 1) {
      times = setInterval(() => {
        localNum--;
        localSetItem('FIRST_WALLPAPER_ENTER_87', localNum);
        if (localNum <= 1) {
          clearInterval(times);
          // localSetItem('FIRST_WALLPAPER_ENTER', 0);
          determinePop();
        }
      }, 1000);
    } else if (!localNum) {
      times = setInterval(() => {
        num--;
        localSetItem('FIRST_WALLPAPER_ENTER_87', num);
        localNum = num;
        if (num <= 1) {
          clearInterval(times);
          // localSetItem('FIRST_WALLPAPER_ENTER', 0);
          determinePop();
        }
      }, 1000);
    } else if (
      localNum === 1 &&
      determineExpire(new Date(localGetItem('ENTER_WALLPAPER')).getTime(), new Date().getTime())
    ) {
      num = 10;
      times = setInterval(() => {
        num--;
        localNum = num;
        localSetItem('FIRST_WALLPAPER_ENTER_87', num);
        if (num <= 1) {
          clearInterval(times);
          // localSetItem('FIRST_WALLPAPER_ENTER', 0);
          determinePop();
        }
      }, 1000);
    }
    return () => {
      let a = localGetItem('FIRST_WALLPAPER_ENTER_87');
      clearInterval(times);
      localSetItem('FIRST_WALLPAPER_ENTER_87', a);
    };
  }, [
    AboutVisible,
    checkUpdateVisible,
    releaseNotesVisible,
    userFeedbackVisible,
    shareVisible,
    wpShowOrder,
    messageVisible,
    pinPopCloseVisible,
    localGetItem('FIRST_WALLPAPER_ENTER_87'),
  ]);

  useEffect(() => {
    if (!userInfo || !userInfo?.st) {
      sessionStorage.setItem('Wp_Turn_List_Add', '');
      sessionStorage.setItem('Wp_Turn_List_Del', '');
    }
  }, [userInfo]);

  // 判断是否弹出壁纸快捷方式弹框
  const determinePop = useCallback(() => {
    let specialList = [
      AboutVisible,
      checkUpdateVisible,
      releaseNotesVisible,
      userFeedbackVisible,
      shareVisible,
      wpShowOrder?.show,
      messageVisible,
      pinPopCloseVisible,
    ];
    if (!specialList.includes(true)) {
      PCStoreJsBridge.checkWALLPAPERxits().then(res => {
        if (res.PIN) {
          dispatch(
            createShortcut({
              tag: true,
              loginInfo: logInfoData,
            }),
          );
        }
      });
      localSetItem('FIRST_WALLPAPER_ENTER_87', 1);
      localSetItem('ENTER_WALLPAPER', new Date());
    } else {
      localSetItem('FIRST_WALLPAPER_ENTER_87', 11);
    }

    // 应该弹框的总弹框数的打桩
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'R_Wallpaper_Desktop',
        label: '',
      }),
    );
  }, [
    AboutVisible,
    checkUpdateVisible,
    releaseNotesVisible,
    userFeedbackVisible,
    shareVisible,
    wpShowOrder,
    messageVisible,
    pinPopCloseVisible,
  ]);

  //判断是否已经过了一个月
  const determineExpire = (sDate, eDate) => {
    if (!sDate) return false;
    if (sDate + 1000 * 60 * 60 * 24 * 30 < eDate) {
      return true;
    }
    return false;
  };

  return (
    <div className={styles.wallpaper_page}>
      <Nav active={active} />
      <Switch>
        {tab.map(item => {
          if (item.codeType === 1) {
            return (
              <Route
                exact
                key={item.code}
                path={`${url}/${item.url}`}
                render={() => <WallpaperRecommend pageType={item.pageType} source={item.source} />}
              />
            );
          }

          if (item.codeType === 2) {
            return (
              <Route
                key={item.code}
                exact
                path={`${url}/${item.url}`}
                render={props => <WallpaperCategory />}
              />
            );
          }

          if (item.codeType === 3) {
            return (
              <Route key={item.code} path={`${url}/${item.url}`}>
                <WallpaperMine />
              </Route>
            );
          }
          if (item.codeType === 4) {
            return (
              <Route
                exact
                key={item.code}
                path={`${url}/${item.url}`}
                render={() => <WallpaperHotRank pageType={item.pageType} source={item.source} />}
              />
            );
          }
        })}
        <Redirect to={`${CONTEXT}/wallpaper/wprecommend`} />
      </Switch>
    </div>
  );
});
